import {useState,useEffect} from "react"
import { getBearer } from "utils/userStorage";
import {generateCodeChallengeFromVerifier,generateCodeVerifier,parseJwt} from "../../utils/OauthUtils"

export default function OAuthCallback(){


    //login link
    // https://staging-identity.3shape.com/connect/authorize?client_id=Avadent.Staging&response_type=code&scope=openid+api+offline_access+communicate.connections.manage+data.companies.read_only+data.users.read_only&redirect_uri=https://stagingeu.avadent.com/oauthcallback&code_challenge=8ufuY0XGCvAt1WMSF8Fl3tfJq2vzFlWeQpa5QEqGGf8&code_challenge_method=S256&response_mode=query

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    var [threedata,setthreedata] = useState(null)
    // https://identity.3shape.com
    // https://staging-identity.3shape.com/

    // generated code challenge = 8ufuY0XGCvAt1WMSF8Fl3tfJq2vzFlWeQpa5QEqGGf8

    useEffect(() => {
        fetch(`${__URLS__["api"]}admin/OauthFlow`, {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${getBearer()}`,
            },
            body:JSON.stringify({
                code:code,
                verifier:localStorage.getItem('verifier'),
                // client_id:'Avadent.Staging',
                // grant_type:'authorization_code',
                // redirect_uri:'https://stagingeu.avadent.com/oauthcallback',
                // code_verifier:'EGt1rnTEdzDppd74PtUYKFmOJlWt_ndhaMRixUy9cBw',
            })
        }).then(res => res.text()).then(data => {
            // console.log(data)
            // setAccess_token(data)
            var threeresponse = JSON.parse(data)
            var jwtdata = parseJwt(threeresponse.idToken)
            localStorage.setItem('jwt',JSON.stringify(jwtdata))
            console.log(jwtdata)
            
            
            
            // threedata.idToken
            // threedata.acceptToken
            // threedata.refreshToken
            // set the idtoken in localstorate and once a minute check it and do a oauth refresh
            // also generate a pkce
            setthreedata(threeresponse)
            var oauthreferrer = localStorage.getItem('oauthreferrer')
            if(oauthreferrer){
                window.location.href = oauthreferrer
            }
        })
    }, []);

    if(threedata == null){
        return <div>loading</div>
    }

    if(threedata.errorMessage){
        return <div>{threedata.errorMessage}</div>
    }
    
    return <div>
        this is the oauthcallback page
        <button onClick={() => {
            fetch(`${__URLS__["api"]}admin/RefreshOauth`, {
                method: 'POST',
                headers: {
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${getBearer()}`,
                },
                body:JSON.stringify({})
            }).then(res => res.text()).then(data => {
                
            })
        }}>request refresh</button>
        <div>{code}</div>
        <div>
            <div>{threedata.idToken}</div>
            <div>{threedata.acceptToken}</div>
            <div>{threedata.refreshToken}</div>
        </div>
        
    </div>
}
